export default __webpack_public_path__ + "static/section_5_button_1-d2a350458a079e8a5373470becf931d3.png";